<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17szRro/tc-custom/9781423640134.jpg?1738411870957" alt="This image is the cover for the book Building Value to Last"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Building Value to Last
      </h1>
      <p class="bookDescription body article font2">
        <b>The life journey of the president and CEO of FJ Management, Inc.—from growing up as the daughter of two entrepreneurs to saving the family business.</b><br/><br/>Discover the inspiring story of how Crystal Maggelet unexpectedly ended up as CEO of her father’s company, guiding Flying J back from bankruptcy and on to great success—all during the throes of the Great Recession of the late 2000s. Through it all, Crystal succeeded by maintaining the core philosophy handed down through generations of the Call family—the importance of building value that will last.<br/><br/>Cowritten by Crystal herself, <i>Building Value to Last</i> compiles accounts from her own recollections and personal journals, as well as from interviews with key personnel.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Crystal Maggelet, Sarah Ryther Francom, Laura Best Smith
      </h2>
      
      <p class="authorDescription body article"><P><B>Crystal Maggelet</B> is president and CEO of FJ Management Inc., a diversified family business, which includes subsidiaries Maverik, a convenience store chain, and the Big West Oil petroleum refinery, as well as a minority stake in Pilot Flying J, the largest travel center operator in the United States. She has a bachelor’s degree from Pepperdine University and an MBA from Harvard University. She currently lives in the Salt Lake City area.</P><br/><br/><P><B>Sarah Ryther Francom</B> is a freelance writer, editor, and publishing consultant. She is the former managing editor of <I>Utah Business Magazine</I>. She currently lives in the Salt Lake City area.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8b1cba4